<template>
    <div class="org-wrapper">
        <div class="glass-card">
            
            <div class="org-header">
                <div class="header-left">
                    <div class="decorative-bar"></div>
                    <span class="org-title drag-handle">{{ organization.orgName }}</span>
                </div>
            </div>
            <div class="org-content">
                <SectionList :sections="organization.sections || []" :orgId="organization.orgId" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import SectionList from './SectionList.vue';

const props = defineProps({
    organization: {
        type: Object,
        required: true,
    },
});
</script>

<style scoped>
.org-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 24px; /* 稍微减小下边距 */
    /* 初始淡入动画 */
    animation: fadeInUp 0.5s ease-out;
}

.glass-card {
    position: relative;
    width: 100%;
    /* 核心液体玻璃质感 - 移除模糊，强调通透和高光 */
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0.1) 100%
    );
    /* 移除 backdrop-filter blur */
    /* border 增强光泽感 */
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-top: 1px solid rgba(255, 255, 255, 0.6);
    border-left: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 20px;
    box-shadow: 
        0 8px 32px 0 rgba(31, 38, 135, 0.05),
        inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    padding: 24px 30px; /* 增加内边距，匹配目标图的呼吸感 */
    overflow: hidden; 
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.glass-card:hover {
    transform: translateY(-2px);
    box-shadow: 
        0 12px 40px 0 rgba(31, 38, 135, 0.1),
        inset 0 0 0 1px rgba(255, 255, 255, 0.3);
}

.org-header {
    margin-bottom: 20px; /* 减小头部间距 */
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
    padding-bottom: 10px;
    position: relative;
    z-index: 1; 
}

.header-left {
    display: flex;
    align-items: center;
}

/* 装饰条 - 增加设计细节 */
.decorative-bar {
    width: 6px;
    height: 20px;
    background: linear-gradient(180deg, #165DFF 0%, #722ED1 100%); /* 渐变色条 */
    border-radius: 3px;
    margin-right: 12px;
    box-shadow: 0 2px 4px rgba(22, 93, 255, 0.3);
}

.org-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.85);
    cursor: grab;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);
}

.org-content {
    position: relative;
    z-index: 1;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.98);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (max-width: 768px) {
    .glass-card {
        padding: 16px;
        border-radius: 16px;
    }
    .org-title {
        font-size: 1.1rem;
    }
}
</style>
